export const getUrlImg = (importImg: any): string => {
    return importImg.default ? importImg.default : importImg;
}